import { useMemo } from 'react';
// Matches both token formats:
//   [RESPONSE_SECTION_1]                      — original format
//   [RESPONSE_SECTION_1|INLINE_ACADEMY_VIDEO] — typed format (useTypedDynamicSectionMarkers)
// Underscores are optional because the LLM sometimes drops them.
const RESPONSE_SECTION_PATTERN = /\[RESPONSE_?SECTION_?(\d+)(?:\|[^\]]+)?\]/g;
export function parseMessageSegments(text, containers) {
  if (!containers.length) {
    return [{
      type: 'text',
      content: text
    }];
  }
  const segments = [];
  const regex = new RegExp(RESPONSE_SECTION_PATTERN.source, 'g');
  const matches = text.matchAll(regex);
  let lastIndex = 0;
  for (const match of matches) {
    var _match$index;
    const matchIndex = (_match$index = match.index) !== null && _match$index !== void 0 ? _match$index : 0;
    if (matchIndex > lastIndex) {
      segments.push({
        type: 'text',
        content: text.slice(lastIndex, matchIndex)
      });
    }

    // Tokens are 1-indexed, containers are 0-indexed.
    const sectionIndex = parseInt(match[1], 10) - 1;
    const container = containers[sectionIndex];
    if (container) {
      segments.push({
        type: 'section',
        container
      });
    }
    lastIndex = matchIndex + match[0].length;
  }
  if (lastIndex < text.length) {
    segments.push({
      type: 'text',
      content: text.slice(lastIndex)
    });
  }
  return segments;
}

// Strips section tokens that don't have a matching container. Tokens with
// a matching container are kept so useDynamicSections can render them.
export function stripUnmatchedSectionTokens(text, containers) {
  return text.replace(new RegExp(RESPONSE_SECTION_PATTERN.source, 'g'), (match, index) => {
    const sectionIndex = parseInt(index, 10) - 1;
    return containers !== null && containers !== void 0 && containers[sectionIndex] ? match : '';
  });
}
export function useDynamicSections(text, dynamicSectionContainers) {
  return useMemo(() => parseMessageSegments(text, dynamicSectionContainers !== null && dynamicSectionContainers !== void 0 ? dynamicSectionContainers : []), [text, dynamicSectionContainers]);
}